import React from 'react';
import { Sparkles } from 'lucide-react';

const HeroSection = ({ title, subtitle }) => {
  return (
    <div className="bg-white rounded-xl shadow-md p-8 mb-8">
      <div className="flex items-center justify-center mb-6">
        <Sparkles className="w-12 h-12 text-pink-500" />
      </div>
      <h2 className="text-3xl font-bold text-center text-gray-900 mb-6">
        {title}
      </h2>
      <p className="text-lg text-gray-700 leading-relaxed text-center mb-6">
        {subtitle}
      </p>
    </div>
  );
};

export default HeroSection;
